import { render, staticRenderFns } from "./ShoppingCartItemWidget.vue?vue&type=template&id=2f340b5c&scoped=true&"
import script from "./ShoppingCartItemWidget.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItemWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItemWidget.vue?vue&type=style&index=0&id=2f340b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f340b5c",
  null
  
)

export default component.exports